
import { ScpEnv } from 'lib-ja-cloud';
import { environment } from '../environments/environment';
import { SSPCommonEnv } from 'lib-sspcommon';


// Provide a value for Environment class defined in the library
// The values will be taken from the actual environment of this application
export const SCP_ENV: ScpEnv = {
    production: environment.production,
    scpCommonApiBaseUrl: environment.scpCommonApiBaseUrl.url,
    sspRoomsApi: environment.sspCommonEndPoint.url,
    sspLicenseApi: environment.sspLicenseApi.url,
    sspMarvelApi: environment.marvelEndPoint.url,
    stackRegion: environment.stackRegion,
    userLimit: environment.userLimit,
    appVersion: environment.version,
    rmpEndPointUser: environment.rmpEndPointUser.url,
}

export const SSPCommon_ENV: SSPCommonEnv = {
    production: environment.production,
    rmpEndPointTenant: environment.rmpEndPointTenant.url,
    marvelEndPoint: environment.marvelEndPoint.url,
    logstashUrl: environment.logstashUrl.url,
    rmpEndPointSubscription: environment.rmpEndPointSubscription.url,
    auditLogElasticSearch: environment.auditLogElasticSearch.url,
    sspEsignageEndPoint: environment.sspEsignageEndPoint.url,
    exportlogUrl: environment.exportlogUrl.url,
    stackRegion: environment.stackRegion,
    appVersion: environment.version, 
    sspLicenseApi: environment.sspLicenseApi.url,
    sspMarvelAgentApi: environment.sspMarvelAgentApi.url,
    version: '0.9.3',
    rmpEndPointNotificationPreferences: environment.rmpEndPointNotificationPreferences.url,
    rmpEndPointUser: environment.rmpEndPointUser.url,
    feat_v33:environment.optional.feat_v33,
    userLimit: environment.userLimit,
    sspAgentApi: environment.sspAgentApi.url,
    esignageAgentAndPlayerMinVersion: environment.esignageAgentAndPlayerMinVersion,
    signageAppUrl:environment.signageAppUrl,
    provisionSubscriptionKey: environment.provisionSubscriptionKey
}
